import { useState, useEffect } from 'react';
import { Tabs, Space, Radio, Table, Input, Divider } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography, Grid } from '@mui/material';
import Tab2 from './Tab2';
import { Tab3 } from './Tab3';
import Tab4 from './Tab4';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import CLIENT from '../../../Models/Client';
import { ColumnsType } from 'antd/es/table';
import DataVClient from '../../../Types/DataVclient';
import Validation from '../../../Models/Validation';
import Hash from '../../../Functions/Security/Hash';

import GetElement from '../../../Models/GetEmelment';
import VerifDay from '../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';


// import "../../../Styles/StyleHome";

//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const VClientPhysique = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader();

  //input de reacherche
  const { Search } = Input;

  const [form] = Form.useForm();
  const [formv] = Form.useForm();

  //const [formv] = Form.useForm();
  //Journées Québec
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [Rejet, SeRejet] = useState(false);
  // const [StartForm, SetStartForm] = useState(true);
  const [DataV, setDataV] = useState<DataVClient[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [index, Setindex] = useState<number>(-1);
  const [SearchR, SetSearchR] = useState<string>("");
  const [, forceUpdate] = useState({});
  const [open, setOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(true)
  const [Modif, SetModif] = useState<any>("");
  const [ValTitle, SetValTitle] = useState<any>("");
  const [Valider, Setvalide] = useState(true);
  const [sbmit, setSbmit] = useState("add");
  const [start, setstart] = useState(false);
  const [Activetabs, SetActivetabs] = useState(false);
  const [Numcli, SetNumcli] = useState<string>("");
  const Navigate=useNavigate();

  const handleValide = () => {
    handRejet();
    setSbmit("V");
    SetModif('');
    SetValTitle(<DialogTitle >Validation d'indice Client</DialogTitle>);
    setOpen(true);

  };

  const handRejet = () => {
    
    HandlerRest();
    SetValTitle(<DialogTitle >Rejet d'indice Client</DialogTitle>);
    setSbmit("R");
    SetModif
      (
        <Form.Item style={{}} label="Motif du Rejet" rules={[{ required: true, message: "" }]} name="Motif">
          <Input.TextArea />
        </Form.Item>
      );
    setOpen(true);


  };

  useEffect(() => {
    forceUpdate({});
    if (start == false) {
      consult();
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      setstart(true);
    }
    else {

    }
  }, []);

  function initialiazeButton() {
    Setvalide(true);
    Setvalide(true);

  }

  const columns: ColumnsType<DataVClient> = [
    {
      title: 'Id Client',
      dataIndex: 'idclient',
      ellipsis: true,
      width: 150,
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.idclient)
        .toLowerCase()
        .includes(value.toLowerCase())    ||
        String(record.Nom)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
        String(record.Prenom)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
        String(record.Agence)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
        String(record.Datcre)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
        String(record.Utilis)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
        String(record.Motif)
            .toLowerCase()
            .includes(value.toLowerCase()) 
      }
    },
    {
      title: 'Nom Client',
      dataIndex: 'Nom',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Prenom',
      dataIndex: 'Prenom',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Agence',
      dataIndex: 'Agence',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Date Creation',
      dataIndex: 'Datcre',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Utilisateur',
      dataIndex: 'Utilis',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Motif',
      dataIndex: 'Motif',
      ellipsis: true,
      width: 200,
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];

  const consultClient = (idclient: string) => {

    let data = Crypter.encrypt(idclient);

    let etat:string='01';
    if(form.getFieldValue('etat')==="R") etat="02";

    let getelement= new GetElement(idclient,user.coduti,"",etat,user.codage);
           
    // let clearNumcli = form.getFieldValue("NUMCLI");

    if (data.length != 0) {
           
      form.setFieldValue("NUMCLI", idclient)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClientTmp,
        headers: {
          'CypherGetElement': Crypter.encrypt(JSON.stringify(getelement)),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {

              let datas: CLIENT = res.Result.Table[0];

              if (res.Result.Table.length > 0) {

                if (datas.TYPCLI.toUpperCase() == 'P') {

                  form.setFieldsValue(res.Result.Table[0]);
                  form.setFieldValue('lib_NUMCLI', datas.NOMCLI);

                  form.setFieldValue('DATNAI', ReformatDate(datas.DATNAI));
                  form.setFieldValue('DateDelcni', ReformatDate(datas.DateDelcni));
                  form.setFieldValue("lib_NUMCLI", form.getFieldValue("NOMCLI"));
                
                  //formv.setFieldValue("ETAT", "VALIDE");

                }
                else {
                  SweetAlert.fire({ title: "Warning", text: " Le Type de client ne correspond pas ", icon: "warning" });
               
                }
              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" });
               
              }

              HandlerRest();
              // cunsultButton()
              // console.log(form.getFieldsValue())
            }
          
          }
        })
        .catch((error) => {

          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })

        });

    }
  }

  const HandlerRest=()=>{
    formv.setFieldValue('Motpas','');
  }

  const onSelectChange = async (newSelectedRowKeys: any) => {

    SetActivetabs(true)

    setLoading(true);

    await consultClient(DataV[newSelectedRowKeys].idclient);

    SetNumcli(DataV[newSelectedRowKeys].idclient)

    if (Rejet == false) Setvalide(false);
    else Setvalide(true)

    setSelectedRowKeys(newSelectedRowKeys);

    Setindex(newSelectedRowKeys)

  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const HandleChangeR = (e: any) => {

    setSelectedRowKeys([]);
    form.resetFields();
    SetActivetabs(false)
    SetNumcli('');
    form.setFieldValue('etat',e.target.value);

    if (e.target.value == "E") {
      consult();
      SeRejet(false);
    } else if (e.target.value == "R") {
      consultR();
      SeRejet(true);
    }
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Liste des Clients Temporaire
        </span>
      ),
      children: (
        <>
          <div className='tabItem' >
            <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
              <Grid item xs={12} className='border-left'>
                {/* <InputForm notRequired label={'Recherche'} onChange={(e:any)=>{SetSearchR(e.target.value.trim()); }} name="ELEMENT" type="string" taille={360} /> */}
                <Form.Item labelCol={{ span: 5 }} name='etat' style={{ fontWeight: 600 }} >
                  <Radio.Group defaultValue={'E'} onChange={HandleChangeR}>
                    <Radio value={'E'} > Encours de validation </Radio>
                    <Radio value={'R'}>Rejetés</Radio>
                  </Radio.Group>
                </Form.Item>
                <Grid container>
                  <Grid item xs={8}>
                    <Typography></Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Search size='middle' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />
                  </Grid>
                </Grid>
                <Table size='small' style={{ marginTop: '2px' }} rowSelection={{ ...rowSelection, selectedRowKeys, type: 'radio' }} scroll={{ y: 300, x: 1200 }} columns={columns} dataSource={DataV} />
              </Grid>
            </Grid>
          </div>
        </>
      )
    }
    ,
    {
      key: '2',
      label: (
        <span>
          <UserOutlined />
          Information Client
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} />,
    },
    {
      key: '3',
      label: (
        <span>
          <ContactsOutlined />
          Autres informations Client
        </span>
      ),
      children: <Tab2 form={form} />,
    },
    {
      key: '4',
      label: (
        <span>
          <ContactsOutlined />
           Photo Et Signature
        </span>
      ),
      children: <Tab3 form={form} />,
    },
    {
      key: '5',
      label: (
        <span>
          <ContactsOutlined />
          Informations Complémentaires
        </span>
      ),
      children: <Tab4 form={form} />,
    }

  ];


  const onFinish = async (values: any) => {

    let validation: Validation = values;
    validation.Codu = user.coduti;
    validation.Indice = DataV[index].idclient;
    validation.Motpas = Hash(validation.Motpas);
 
     setLoading(true);

    if (DataV[index].Utilis != user.coduti) {

      if (sbmit == "V") {
        validation.Motif = "";
        validation.Etat = 1;
      
        setIsSubmit(true)
        //let group = profilsDistant.find(()=>)
        console.log('Received values of form: ', Crypter.encrypt(JSON.stringify("")));

        let data = Crypter.encrypt(JSON.stringify(validation));

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ValideClient,
          headers: {
            'CypherValidion': data,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          }
        };
           
        axios.request(config)
          .then((response) => {
          
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;

              if (res.StatutCode == 200) {
                form.resetFields();
                localStorage.clear();
 
                setIsSubmit(false);
                setLoading(false);
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
                setOpen(false);
                consult();
                HandlerRest();

                localStorage.clear();
                initialiazeButton();

                setSbmit("");
              }
              else {
                setLoading(false);
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
          });

      }

      if (sbmit == "R") {
        validation.Etat = 2;
   
        setLoading(true);
        setIsSubmit(true);

        console.log('Received values of form: ');

        let data = Crypter.encrypt(JSON.stringify(validation));

        let config = {
          method: 'Post',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ValideClient,
          headers: {
            'CypherValidion': data,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
        };

        await axios.request(config)
          .then((response) => {
          
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;

              if (res.StatutCode == 200) {

                form.resetFields()
                setIsSubmit(false)
                setLoading(false);
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });

                setOpen(false);
                consult();

                initialiazeButton();
                localStorage.setItem(Data.LocalVariable.reset, '1');

                setSbmit("");
              }else {
                setLoading(false);
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
              }
             
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });

      }

    }
    else{
      SweetAlert.fire({ title: "Error", text: "impossible de valider un indice créer par vous", icon: "error" })
      setLoading(false);
    }
   
  };


  const consult = async () => {

    setDataV([]);

    setLoading(true);

    let TypCli = 'P'
    let Etat = '01'
    let codage = user.codage

    let datat: DataVClient[] = [];

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetAllClientTmp,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherTypCli': Crypter.encrypt(JSON.stringify(TypCli)),
        'CypherEtat':   Crypter.encrypt(JSON.stringify(Etat)),
        'CypherCODAGE': Crypter.encrypt(JSON.stringify(codage)),
        'CypherCodeU':  Crypter.encrypt(JSON.stringify(user.coduti))
      }
    };

    await
      axios(config)
        .then((response) => {

          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              if (datas.length === 0) {
                //console.log("aucun élément");
              }
              else {

                datas.map((data: any, indice: number) => {
                  datat.push({
                    key: indice,
                    idclient: data.NUMCLI,
                    Nom: data.NOMCLI,
                    Prenom: data.PRECLI,
                    Agence: data.CODAGE,
                    Datcre: data.DATCRE ? (new Date(data.DATCRE.substring(0, 10))).toLocaleDateString("fr") + " "+ data.DATCRE.substring(11, 19):'' ,
                    Utilis: data.UTILIS,
                    Tel: data.telCli,
                    RelObject: data
                  });
                });

                setDataV(datat);
              }
            }
          
          }
          setLoading(false);

        }).catch((error) => {
          console.log(error)
          setLoading(false);
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        })
  }


  const consultR = async () => {

    setLoading(true);
    setDataV([]);

    let TypCli = 'P'
    let Etat = '02'
    let codage = ''

    let datat: DataVClient[] = [];

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetAllClientTmp,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherTypCli': Crypter.encrypt(JSON.stringify(TypCli)),
        'CypherEtat': Crypter.encrypt(JSON.stringify(Etat)),
        'CypherCODAGE': Crypter.encrypt(JSON.stringify(codage)),
        'CypherCodeU':  Crypter.encrypt(JSON.stringify(user.coduti))
      }
    };

    await
      axios(config)
        .then((response) => {

          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              if (datas.length === 0) {
                //console.log("aucun élément");
              }
              else {
                datas.map((data: any, indice: number) => {
                  datat.push({
                    key: indice,
                    idclient: data.NUMCLI,
                    Nom: data.NOMCLI,
                    Prenom: data.PRECLI,
                    Agence: data.CODAGE,
                    Datcre: data.DATCRE ? (new Date(data.DATCRE.substring(0, 10))).toLocaleDateString("fr") + " "+ data.DATCRE.substring(11, 19):'' ,
                    Utilis: data.UTILIS,
                    Motif: data.MOTIFREJET,
                    Tel: data.telCli,
                    RelObject: data
                  });
                });
                setDataV(datat);
              }
            }
           
          }
          setLoading(false);

        }).catch((error) => {
          console.log(error)
          setLoading(false);
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        })
  }




  return (
    <div>
      <div className='tab'>
        <Typography align='center' className='formTitle'><b>{window.location.pathname+'sique'}</b></Typography>
        <Spin spinning={loading} size='large' style={{ color: '#116599', zIndex: 200 }} >
          <div>
            <Dialog
              sx={{ zIndex: 1 }}
              open={open}  >
              <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={formv} name="dynamic_form_complex" onFinish={onFinish} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                {ValTitle}
                <DialogContent >
                  <DialogContentText sx={{ height: '2em', marginTop: '1em' }}>
                    {/* validation de creation du client   { DataV[index].Nom ? DataV[index] != "" || 'undefined' :""}  { DataV[index].Prenom ? index != -1 || 'undefined' :"" }   */}
                  </DialogContentText>
                  <Form.Item label="Enter password" rules={[{ required: true, message: "password is required" }]} name="Motpas">
                    <Input.Password />
                  </Form.Item>
                  {
                    Modif
                  }
                </DialogContent>
                <Divider />
                <DialogActions  >
                  <Button size='middle' onClick={e => { setOpen(false);HandlerRest();}} disabled={Valider} block  >
                    Annuler
                  </Button>
                  <Button size='middle'  disabled={loading} htmlType="submit" block  >
                    Valider
                  </Button>
                </DialogActions>
              </Form>
            </Dialog>
          </div>
          <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>
            <div className='bG'>
              <legend><Typography color={"#116599"}>Actions</Typography></legend>
              <Form.Item shouldUpdate className='bouttong'>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Button size='large' className='bt_add' disabled={false} onClick={() => { form.resetFields(); SetNumcli(""); SetActivetabs(false); setSelectedRowKeys([]); form.setFieldValue('etat', "E"); consult(); initialiazeButton(); }} type="ghost" htmlType="button" block  >
                    Actualiser
                  </Button>
                  <Button size='large' onClick={e => { handleValide(); }} className='bt_add' disabled={Valider} type="ghost" htmlType="button" block  >
                    Valider
                  </Button>
                  <Button size='large' onClick={e => { handRejet() }} className='bt_add' disabled={Valider} type="ghost" htmlType="button" block  >
                    Rejetter
                  </Button>
                  <Button size='large' className='bt_add' type="ghost" htmlType="button" block  >
                    Imprimer
                  </Button>
                </Space>
              </Form.Item>
            </div>
            <div className='clientP'>
              <div >
                <Tabs onChange={e => { if (Activetabs == true) { consultClient(Numcli); } }} size='large' type="card" defaultActiveKey="1" items={items} />
              </div>
              <div>
              </div>
            </div>
          </Form>
        </Spin>
      </div>
      {/* </Spin> */}
    </div>

  );
}
export default VClientPhysique;